import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import { StyledFixaModalBody } from "./StyledModalComponents";
import { FixaSwitch } from "@coworker/apprestructured/src/shared/wrappers/FixaSwitch/FixaSwitch";
import { TeamStatus } from "@coworker/apprestructured/src/shared/types/team";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { Trans } from "@coworker/locales";

export type TeamModalInputs = {
  teamName: string;
  teamStatus: TeamStatus.ACTIVE | TeamStatus.INACTIVE;
  isProductQualityTeam: boolean;
};

interface TeamModalInputsProps {
  onChange: (
    field: keyof TeamModalInputs,
    value: TeamModalInputs[typeof field]
  ) => void;
  teamName: StoreTeam["name"];
  isProductQualityTeam: StoreTeam["is_product_quality"];
}

export const TeamModalInputs = ({
  teamName,
  isProductQualityTeam,
  onChange,
}: TeamModalInputsProps) => (
  <StyledFixaModalBody>
    <FixaInputField
      label={<Trans>capitalisedTeamNameString</Trans>}
      type="text"
      id="teamNameInput"
      value={teamName}
      onChange={(e) => onChange("teamName", e.currentTarget.value)}
    />
    <FixaSwitch
      id="isProductQualityTeamSwitcher"
      label={<Trans>productQualityTeamString</Trans>}
      checked={isProductQualityTeam}
      value={""}
      onChange={() => onChange("isProductQualityTeam", !isProductQualityTeam)}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  </StyledFixaModalBody>
);
